import * as React from "react";
import { Breadcrumb, PageHeader, Row } from "antd";
import { Link, Redirect, Route, Switch, useLocation } from "react-router-dom";

import { ShareTwitter, ShareFacebook } from "../common";
import { DATA } from "../common/data";

import MainPage from "./main";
import { AccountSecurity, DeviceSecurity, OnlineFraud } from "./lectures";

import "./index.css";

const LecturePage = () => {
  const location = useLocation();
  const url = location.pathname.split("/")[2];
  const title =
    DATA.find((chapter) => chapter.url === url)?.title || "講座一覧";
  return (
    <>
      {url && (
        <div style={{ paddingTop: 12, paddingLeft: 24 }}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/lectures">講座一覧</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {DATA.find((chapter) => chapter.url === url)?.title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      )}
      <PageHeader
        title={title}
        extra={[<ShareFacebook />, <ShareTwitter />]}
        style={{ paddingTop: url && 0 }}
      />
      <Row style={{ padding: 24, paddingTop: 0 }} className="lecture-page">
        <Switch>
          <Route exact path="/lectures/online-fraud" component={OnlineFraud} />
          <Route
            exact
            path="/lectures/account-security"
            component={AccountSecurity}
          />
          <Route
            exact
            path="/lectures/device-security"
            component={DeviceSecurity}
          />
          <Route exact path="/lectures" component={MainPage} />
          <Redirect to="/lectures" />
        </Switch>
      </Row>
    </>
  );
};

export default LecturePage;
